import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import SideMenu from '../Partials/SideMenu';
import Routes, { RenderRoutes } from '../../services/Routes';
import BaseStyle from '../../assets/themes/BaseStyle';

const useStyles = BaseStyle();

export default function Resources() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <SideMenu classes={classes} open={open} onClick={handleDrawerClose} />
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <RenderRoutes routes={Routes} /> Resources
        </Container>
      </main>
    </div>
  );
}
